export default "__VITE_ASSET__33EEchbm__"